import { ToolOwnershipEnum } from "@enums/toolOwnership.enum";
import { Model } from "@interfaces/model.interface";

export interface ProductionTool extends Model {
	clientId: number;
	criticalLevelBlows?: number;
	currentServicePeriodBlows: number;
	dateRequired?: Date;
	expectedLifetimeBlows: number;
	imageURLs: string; // JSON format list of image urls
	isStackable: boolean;
	lastServiceDate?: Date;
	lifetimeBlows: number;
	name: string;
	notes: string;
	ownership: ToolOwnershipEnum;
	poNumber: string;
	poURL: string;
	projectId?: number;
	rackLocation: string;
	serviceIntervalBlows: number;
	siteId: number;
	toolHeight: number;
	toolLength: number;
	toolWeightLower: number;
	toolWeightUpper: number;
	toolWidth: number;
	toolingTypeId: number;
	totalStorageVolume: number;
	totalToolWeight: number;
	warningLevelBlows?: number;
}

export class ProductionTool implements ProductionTool {
	constructor(data?: Partial<ProductionTool>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}